import { render, staticRenderFns } from "./ManagersList.vue?vue&type=template&id=0cad973d&scoped=true&lang=pug&"
import script from "./ManagersList.vue?vue&type=script&lang=js&"
export * from "./ManagersList.vue?vue&type=script&lang=js&"
import style0 from "./ManagersList.vue?vue&type=style&index=0&id=0cad973d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad973d",
  null
  
)

export default component.exports